import { render, staticRenderFns } from "./QuestionImage.vue?vue&type=template&id=59307a82&scoped=true"
import script from "./QuestionImage.vue?vue&type=script&lang=js"
export * from "./QuestionImage.vue?vue&type=script&lang=js"
import style0 from "./QuestionImage.vue?vue&type=style&index=0&id=59307a82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59307a82",
  null
  
)

export default component.exports